import axios from 'axios'
import { isRuntimePackageRequest, runtimePackageError } from '@/utils/runtimePackageRequest'
import { isIntegrationBuildRequest, integrationBuildError } from '@/utils/integrationBuildRequest'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { invalidateIntegrationIdentity } from '@/utils/integrationClientSession'
import { isIntegrationClientRequest, integrationClientError } from '@/utils/integrationClientRequest'
import { isIntegrationOutboxRequest, integrationOutboxError } from '@/utils/integrationOutboxRequest'
import { isIntegrationReconciliationRequest, integrationReconciliationError } from '@/utils/integrationReconciliationRequest'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API + '/api', // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  if (isRuntimePackageRequest(error && error.config)) return Promise.reject(runtimePackageError())
  if (isIntegrationBuildRequest(error && error.config)) return Promise.reject(integrationBuildError())
  if (isIntegrationReconciliationRequest(error && error.config)) {
    return Promise.reject(integrationReconciliationError())
  }
  if (isIntegrationOutboxRequest(error && error.config)) {
    return Promise.reject(integrationOutboxError())
  }
  if (isIntegrationClientRequest(error && error.config)) {
    return Promise.reject(integrationClientError())
  }
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非200是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res && res.code === 401) invalidateIntegrationIdentity()
    if (isRuntimePackageRequest(response.config)) {
      if (!res || res.code !== 200) return Promise.reject(runtimePackageError(res, response.status))
      return res
    }
    if (isIntegrationBuildRequest(response.config)) {
      if (!res || res.code !== 200) return Promise.reject(integrationBuildError(res, response.status))
      return res
    }
    if (isIntegrationReconciliationRequest(response.config)) {
      if (!res || res.code !== 200) return Promise.reject(integrationReconciliationError(res, response.status))
      return res
    }
    if (isIntegrationOutboxRequest(response.config)) {
      if (!res || res.code !== 200) return Promise.reject(integrationOutboxError(res, response.status))
      return res
    }
    if (isIntegrationClientRequest(response.config)) {
      if (!res || res.code !== 200) return Promise.reject(integrationClientError(res, response.status))
      return res
    }
    if (res.code !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    const status = error && error.response && error.response.status
    const body = error && error.response && error.response.data
    if (status === 401 || (body && body.code === 401)) invalidateIntegrationIdentity()
    if (isRuntimePackageRequest(error && error.config)) return Promise.reject(runtimePackageError(body, status))
    if (isIntegrationBuildRequest(error && error.config)) return Promise.reject(integrationBuildError(body, status))
    if (isIntegrationReconciliationRequest(error && error.config)) {
      return Promise.reject(integrationReconciliationError(body, status))
    }
    if (isIntegrationOutboxRequest(error && error.config)) {
      return Promise.reject(integrationOutboxError(body, status))
    }
    if (isIntegrationClientRequest(error && error.config)) {
      return Promise.reject(integrationClientError(body, status))
    }
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js